import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import config from './config/index.js';
import consts from './config/consts.js';
import api from './api/index.js';
import * as commonFun from './utils/function.js';
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component

import {
    ToolboxComponent,
    DataZoomComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';

// 注册必须的组件
echarts.use([
    ToolboxComponent,
    DataZoomComponent,
    LegendComponent,
    LineChart,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    BarChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer
]);
Vue.prototype.$echarts = echarts;
// // 接下来的使用就跟之前一样，初始化图表，设置配置项
// var myChart = echarts.init(document.getElementById('main'));
// myChart.setOption({
//   // ...
// });
import moment from 'moment';


import './plugins/element.js';

Vue.config.productionTip = false;

Vue.prototype.$config = config;
Vue.prototype.$const = consts;
Vue.prototype.$api = api;
Vue.prototype.$commonFun = commonFun;
Vue.prototype.$moment = moment;
Vue.prototype.$EventBus = new Vue();
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')